module.exports = __webpack_public_path__ + "static/img/r_020.982b339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_020.jpg
// module id = 377e
// module chunks = 1